/**
 * 公共接口
 * @author VenDream
 * @since 2021-9-14
 */

import { post } from '@fe/common/lib/ajax';

const rpConf = window.RPCONFIG || {};
const { bwsHost } = rpConf || {};

/**
 * 生成对应url的短链
 *
 * @export
 * @param {string} url url
 */
export function getShortUrl(url) {
  const uri = `${bwsHost}/api/shorturl/generate`;
  return post(
    uri,
    {
      url: encodeURIComponent(url),
    },
    { credentials: true, timeout: 5000 }
  );
}
